import { toast } from '../components/toast/toast.js';

function copyToClipboard(content, toastMsg) {
    navigator.clipboard &&
        navigator.clipboard
            .writeText(content)
            .then(() => {
            toast.success(toastMsg || "Link Copied");
        })
            .catch((e) => console.log(e));
}

export { copyToClipboard };
//# sourceMappingURL=copyToClipboard.js.map
